import script from "./GameCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameCard.vue?vue&type=script&setup=true&lang=ts"

import "./GameCard.vue?vue&type=style&index=0&id=ad0323a0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad0323a0"]])

export default __exports__